export const SESSION_INIT_URL = `${process.env.REACT_APP_ENERGYMNTR_URL}login/index.php?autologin=true&`;
export const ENERGYMNTR_URL = process.env.REACT_APP_ENERGYMNTR_URL;
export const SES_API = process.env.REACT_APP_SES_API_URL;
export const CHECK_CODE_API = process.env.REACT_APP_CHECK_CODE_API_URL;
export const GET_LANG_API = process.env.REACT_APP_GET_LANG_API_URL;
export const MAX_STEPS = 4;
export const MAX_CRUISE_SCREEN_TITLE_NUM = 32;
export const MIN_CRUISE_SECONDS_NUM = 10;
export const MAX_CRUISE_SECONDS_NUM = 3600;
export const CRUISE_PER_PAGE = 10;
export const CRUISE_SETTING_URL = process.env.REACT_APP_CRUISE_SETTING_API_URL;
export const CRUISE_API_KEY = process.env.REACT_APP_CRUISE_SETTING_API_KEY;
export const PR_CONTENT_URL = process.env.REACT_APP_PR_CONTENT_URL;
export const GET_MWID_AUTHZDB = process.env.REACT_APP_AUTHZ_URL;
export const AUTHZDB_BASEURL = process.env.REACT_APP_AUTHZ_URL;
export const GRAND_ARCH_URL = process.env.REACT_APP_GRAND_ARCH_URL;
export const PPMS_URL = process.env.REACT_APP_PPMS_URL;
export const TERM_VER = 5;
export const MIERUKA_MANUAL = 'https://www.lapsys.co.jp/common/download/MierukaWeb_Manual.pdf';
export const ASSET_LIST = [
  {
    id: 'solar_standard_s',
    name: 'Standard solar power generation (All electricity sales)',
  },
  {
    id: 'solar_standard_surplus_electricity_sales',
    name: 'Standard solar power generation (Surplus electricity sales)',
  },
  {
    id: 'solar_standard_selfconsumption',
    name: 'Standard solar power generation (Self consumption)',
  },
  {
    id: 'selfconsumption_standard_s',
    name: 'Self consumption solar power generation',
  },
  {
    id: 'selfconsumption_standard_battery_s',
    name: 'Self consumption solar power generation + Battery',
  },
];
export const ASSET_DEFAULT_SCREENS = {
  solar_standard_s: {
    titleList: [
      '',
      '1日のトレンドグラフ',
      '発電電力量の1日の変化',
      '発電電力量の1ヶ月の変化',
      '発電電力量の1年の変化',
      '太陽光発電の特徴',
      '太陽電池の仕組み',
      '電力の有効な活用',
    ],
    screenSetting: [
      {
        screenId: 'keisoku',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'graph_trend',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'graph_daily',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'graph_monthly',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'graph_annual',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'taiyokohatsudennotokucho',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'taiyodenchinoshikumi',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'denryokunoyukokatsuyo',
        assetId: 'solar_standard_s',
      },
    ],
  },
  selfconsumption_standard_s: {
    titleList: [
      '',
      '1日のトレンドグラフ',
      '電力量の1日の変化',
      '電力量の1ヶ月の変化',
      '電力量の1年の変化',
      '太陽電池の仕組み',
      '自家消費型太陽光発電とは',
      '発電したエネルギーを無駄にしない自家消費型太陽光発電',
    ],
    screenSetting: [
      {
        screenId: 'keisoku',
        assetId: 'selfconsumption_standard_s',
      },
      {
        screenId: 'graph_trend',
        assetId: 'selfconsumption_standard_s',
      },
      {
        screenId: 'graph_daily',
        assetId: 'selfconsumption_standard_s',
      },
      {
        screenId: 'graph_monthly',
        assetId: 'selfconsumption_standard_s',
      },
      {
        screenId: 'graph_annual',
        assetId: 'selfconsumption_standard_s',
      },
      {
        screenId: 'taiyodenchinoshikumi',
        assetId: 'selfconsumption_standard_s',
      },
      {
        screenId: 'jikashouhitowa',
        assetId: 'selfconsumption_standard_s',
      },
      {
        screenId: 'chisanchisho',
        assetId: 'selfconsumption_standard_s',
      },
    ],
  },
  solar_standard_surplus_electricity_sales: {
    titleList: [
      '',
      '1日のトレンドグラフ',
      '発電電力量の1日の変化',
      '発電電力量の1ヶ月の変化',
      '発電電力量の1年の変化',
      '太陽光発電の特徴',
      '太陽電池の仕組み',
      '電力の有効な活用',
    ],
    screenSetting: [
      {
        screenId: 'keisoku',
        assetId: 'solar_standard_surplus_electricity_sales',
      },
      {
        screenId: 'graph_trend',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'graph_daily',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'graph_monthly',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'graph_annual',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'taiyokohatsudennotokucho',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'taiyodenchinoshikumi',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'denryokunoyukokatsuyo',
        assetId: 'solar_standard_s',
      },
    ],
  },
  solar_standard_selfconsumption: {
    titleList: [
      '',
      '1日のトレンドグラフ',
      '発電電力量の1日の変化',
      '発電電力量の1ヶ月の変化',
      '発電電力量の1年の変化',
      '太陽光発電の特徴',
      '太陽電池の仕組み',
      '電力の有効な活用',
    ],
    screenSetting: [
      {
        screenId: 'keisoku',
        assetId: 'solar_standard_selfconsumption',
      },
      {
        screenId: 'graph_trend',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'graph_daily',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'graph_monthly',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'graph_annual',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'taiyokohatsudennotokucho',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'taiyodenchinoshikumi',
        assetId: 'solar_standard_s',
      },
      {
        screenId: 'denryokunoyukokatsuyo',
        assetId: 'solar_standard_s',
      },
    ],
  },
  selfconsumption_standard_battery_s: {
    titleList: [
      '',
      '1日のトレンドグラフ',
      '電力量の1日の変化',
      '電力量の1ヶ月の変化',
      '電力量の1年の変化',
      '蓄電池のしくみ',
      '蓄電池でエネルギーを賢く使う',
      '災害時に役立つ蓄電池システム',
      '自家消費型太陽光発電とは',
      '地産地消でエネルギーを無駄なく使う',
    ],
    screenSetting: [
      {
        screenId: 'keisoku',
        assetId: 'selfconsumption_standard_battery_s',
      },
      {
        screenId: 'graph_trend',
        assetId: 'selfconsumption_standard_battery_s',
      },
      {
        screenId: 'graph_daily',
        assetId: 'selfconsumption_standard_battery_s',
      },
      {
        screenId: 'graph_monthly',
        assetId: 'selfconsumption_standard_battery_s',
      },
      {
        screenId: 'graph_annual',
        assetId: 'selfconsumption_standard_battery_s',
      },
      {
        screenId: 'chikudenchinoshikumi',
        assetId: 'selfconsumption_standard_battery_s',
      },
      {
        screenId: 'kashikokutsukau',
        assetId: 'selfconsumption_standard_battery_s',
      },
      {
        screenId: 'saigainiyakudatsu',
        assetId: 'selfconsumption_standard_battery_s',
      },
      {
        screenId: 'jikashouhitowa',
        assetId: 'selfconsumption_standard_s',
      },
      {
        screenId: 'chisanchisho',
        assetId: 'selfconsumption_standard_battery_s',
      },
    ],
  },
};
export const PPA_API_BASEURL = process.env.REACT_APP_PPAAPI_BASEURL;
export const PPA_PRODUCTLIST_NUM = 50;
export const PPA_PATTERNNAME_LENGTH = 20;
export const PPA_DEFAULTSETTING = {
  supplierId: '',
  patternName: 'パターン',
  isDefault: false,
  invoiceCalculation: [
    {
      calcTarget: 'consumption',
      basePrice: '',
      reEneLevy: '',
      fuelAdjustmentCost: '',
      pricingRange: {
        buy: [
          {
            over: 0,
            unitPrice: '',
          },
          {
            over: '',
            unitPrice: '',
          },
        ],
        selfConsumption: [
          {
            over: 0,
            unitPrice: '',
          },
          {
            over: '',
            unitPrice: '',
          },
        ],
        consumption: [
          {
            over: 0,
            unitPrice: '',
          },
          {
            over: '',
            unitPrice: '',
          },
        ],
      },
    },
  ],
  coefficient: {
    smartPhone: 111,
    electricCar: 5.4,
  },
  screens: [
    {
      asset: {
        screenId: 'skelton',
      },
      measuredItems: 'noSellConsumption',
    },
  ],
};

// 0: 正常, 1: ロード中, 2: 正常通信だがデータがない, -1: 通信できてない
export const API_STATUS = {
  OK: 0,
  LOADING: 1,
  NO_BODY: 2,
  NO_RESPONSE: -1,
};

/**
 * ヘッダの表示パターン
 *  0: マイページのデフォルト
 *  1: マイページの PPA
 *  2: 管理画面
 */
export const HEADER_VIEW_PATTERN = {
  DEFAULT: 0,
  PPA: 1,
  MANAGEMANT: 2,
  CONFIRMATION: 3,
};

export function getInvoiceApiUrl(param) {
  return process.env.REACT_APP_INVOICE_URL + param;
}

/** ラプラスパスポート API のリクエストで指定するメソッド */
export const LAPLACE_PASSPORT_API_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};
/** アカウントユーザの権限 */
export const ACCOUNT_USER_TYPE = {
  PRIMARY_ADMIN: 'primary_admin',
  ADMIN: 'admin',
  GENERAL: 'general',
};
/** アカウントユーザの管理者権限 */
export const ADMIN_USER_TYPES = [ACCOUNT_USER_TYPE.PRIMARY_ADMIN, ACCOUNT_USER_TYPE.ADMIN];
/** アカウントユーザの確認ステータス */
export const ACCOUNT_USER_CONFIRMATION_STATUS = {
  UNCONFIRMED: 'unconfirmed',
  CONFIRMED: 'confirmed',
  REJECTED: 'rejected',
};
export const SOLAR_PRO_LICENSE_NAME = 'Solar Pro ネットワーク認証版';
